import { render, staticRenderFns } from "./MenuCategory.vue?vue&type=template&id=092bca5a&shadow"
import script from "./MenuCategory.vue?vue&type=script&lang=js&shadow"
export * from "./MenuCategory.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports